import {useCallback, useEffect, useState, useRef} from "react";
import {useSearchParams} from "react-router-dom";

// const

const useAll = ({fetchData, searchFunction}) => {
    const [statsVisible, setStatsVisible] = useState(true);
    const [search, setSearch] = useState("");
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [data, setData] = useState({});
    const [currentData, setCurrentData] = useState({});
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const [searchParams] = useSearchParams();

    const userName = searchParams.get("name");

    const firstRender = useRef(true);

    useEffect(() => {
        if(firstRender.current) {
            firstRender.current = false;
            const fetchAll = async () => {
                try {
                    setLoading(true);
                    const result = await fetchData();
                    setLoading(false);
                    setData(result);
                    setCurrentData(result);
                    if(userName){
                        setSearch(userName)
                    }

                } catch (error) {
                    console.log(error)
                }
            };

            fetchAll();
            return;
        }

        setLoading(true);
        setTimeout(()=> {
            setLoading(false);
        }, 1000)
    }, [pagination.pageSize, pagination.current, filteredInfo, sortedInfo, search])

    const toogleStatsVisible = () => {
        setStatsVisible(prevState => !prevState);
    }

    const handleChange = useCallback((pagination, filters, sorter, {currentDataSource}) => {

        setCurrentData(prevData => ({...prevData, hits: currentDataSource}))
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    }, [setFilteredInfo, setSortedInfo]);

    const resetFilters = useCallback(() => {
        setFilteredInfo({});
    }, [setFilteredInfo]);

    const resetSorters = useCallback(() => {
        setSortedInfo({});
    }, [setSortedInfo]);

    const handleSearch = ({target}) => setSearch(target.value);

    return {
        search,
        setSearch,
        statsVisible,
        filteredInfo,
        sortedInfo,
        data,
        setData,
        currentData,
        setCurrentData,
        loading,
        pagination,
        handleChange,
        resetFilters,
        resetSorters,
        handleSearch,
        toogleStatsVisible,
    }
}

export default useAll;
